import React from 'react';
import Seo from '../components/Seo';
import useFetch from '../hooks/useFetch';
import SectionRenderer from '../components/home/SectionRenderer';
import { PageLoader } from '../components/common/Spinner';

export default function Home() {
  const { data, loading } = useFetch('/settings/home');
  return (
    <>
      <Seo />
      {loading && !data ? <PageLoader /> : <SectionRenderer sections={data?.sections || []} />}
    </>
  );
}
